import { css as _css } from "@emotion/react";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { useTheme } from '@emotion/react';
import { motion, AnimatePresence } from 'framer-motion';
import useTimeoutFn from 'react-use/lib/useTimeoutFn';
import Portal from '@reach/portal';
import useNotificationsState from '../hooks/useNotifications';
import { misc } from '../assets/styles/utility';
import Icon from './Icon';
import { jsx as ___EmotionJSX } from "@emotion/react";

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : {
  name: "c5hulr-Notification",
  styles: "margin-top:0;label:Notification;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Notification = ({
  notification
}) => {
  const theme = useTheme();
  const remove = useNotificationsState(state => state.remove);

  function fn() {
    remove(notification.index);
  }

  const [, cancel] = useTimeoutFn(fn, notification.timeout);
  return ___EmotionJSX(motion.li, {
    tabIndex: "-1",
    role: "button",
    layout: true,
    initial: {
      opacity: 0,
      y: theme.space.large,
      scale: 0.5
    },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1
    },
    exit: {
      opacity: 0,
      scale: 0.5,
      transition: {
        duration: 0.2
      }
    },
    onClick: () => {
      cancel(); // Remove pending timeout

      remove(notification.index);
    },
    css: /*#__PURE__*/_css({
      display: 'grid',
      background: theme.color.light.base,
      border: theme.border.base,
      boxShadow: theme.boxShadow.base,
      alignItems: 'center',
      cursor: 'pointer',
      gap: theme.space.small,
      gridTemplateColumns: 'auto 1fr',
      padding: theme.space.base,
      borderRadius: theme.borderRadius.large,
      fontSize: theme.fontSize.small,
      lineHeight: theme.lineHeight.small,
      '&:not(:last-of-type)': {
        marginBottom: theme.space.small
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Notification;")
  }, ___EmotionJSX("div", {
    css: /*#__PURE__*/_css({
      borderRadius: theme.borderRadius.rounded,
      background: theme.color[notification.status === 'success' ? 'primary' : 'danger'].base,
      height: theme.height.xxsmall,
      width: theme.height.xxsmall,
      display: 'grid',
      placeItems: 'center'
    }, process.env.NODE_ENV === "production" ? "" : ";label:Notification;")
  }, ___EmotionJSX(Icon, {
    size: "small",
    icon: notification.status === 'success' ? 'check' : 'close',
    css: /*#__PURE__*/_css({
      color: theme.contrast.base,
      top: 'auto' // Reset default top offset

    }, process.env.NODE_ENV === "production" ? "" : ";label:Notification;")
  })), ___EmotionJSX("div", {
    className: theme.settings.classes.trim
  }, notification.title && ___EmotionJSX("h4", {
    css: /*#__PURE__*/_css({
      fontSize: theme.fontSize.medium,
      marginBottom: theme.space.xsmall
    }, process.env.NODE_ENV === "production" ? "" : ";label:Notification;")
  }, notification.title), ___EmotionJSX("p", {
    css: _ref
  }, notification.body)));
};

const Notifications = () => {
  const notifications = useNotificationsState(state => state.notifications);
  const theme = useTheme();
  return ___EmotionJSX(Portal, null, ___EmotionJSX("ul", {
    css: /*#__PURE__*/_css({
      margin: 0,
      position: 'fixed',
      top: 0,
      right: 0,
      padding: theme.space.small,
      zIndex: 10,
      overflowY: 'auto',
      height: '100%',
      width: 300,
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      WebkitOverflowScrolling: 'touch',
      '&::-webkit-scrollbar': {
        width: 0
      },
      '&:empty': [misc.hide]
    }, process.env.NODE_ENV === "production" ? "" : ";label:Notifications;")
  }, ___EmotionJSX(AnimatePresence, {
    initial: false
  }, notifications.map(notification => ___EmotionJSX(Notification, {
    key: notification.index,
    notification: notification
  })))));
};

export default Notifications;